import React from 'react'
import PropTypes from 'prop-types'
import { Grid, H2, P, Spacer } from '../Globals/index.style'
import { Row, Col } from 'react-styled-flexboxgrid'
import Card from '../Cards/Cards'
import {
  StyledCol,
  CardLink,
  CardSection,
  CardCtabtn,
  TextHighlight,
} from './style'

const CardInner = ({ text, highlight, content }) => (
  <>
    <TextHighlight font-weight="700" highlight={highlight}>
      <span>{content}</span>
    </TextHighlight>

    {text && <P>{text}</P>}
  </>
)

const isExternalLink = (href) =>
  RegExp('^((http|https)?://)(.*)').test(href) && !RegExp('^/').test(href)

const BlockCards = ({ cards, cardsAsRows, subtitle, title }) => {
  return (
    <CardSection>
      <Grid>
        {(title || subtitle) && (
          <Row center="lg">
            <Col xs={12} lg={9}>
              <div align="center">
                {title && <H2 data-key="cards__heading">{title}</H2>}
                {subtitle && <div data-key="cards__subtext">{subtitle}</div>}
              </div>
              <span size="xl" breakpoints={{ lg: 'xxl' }} />
              <Spacer />
            </Col>
          </Row>
        )}
        <Row center="lg">
          <Col xs={12}>
            <Row center="lg">
              {cards.map((card, index) => {
                const showContent = !!(
                  card.text ||
                  card.content ||
                  card.imageSrc
                )
                const target = isExternalLink(card.url) ? '_blank' : '_self'
                return (
                  <StyledCol
                    xs={12}
                    sm={6}
                    lg={4}
                    key={`feature-card-${card.imageSrc}-${index}`}
                  >
                    {showContent && (
                      <CardLink
                        as={card.linkComponent || 'a'}
                        to={card.url}
                        href={card.url}
                        target={target}
                      >
                        <Card
                          image={card.imageSrc}
                          imageAltText={card.imageSrc && (card.imageAlt || '')}
                          cta={
                            card.ctaText && (
                              <CardCtabtn>{card.ctaText}</CardCtabtn>
                            )
                          }
                          borderColor={card.borderColor}
                          row={cardsAsRows}
                          youtubeVideoId={card.youtubeVideoId}
                        >
                          {showContent && (
                            <CardInner
                              text={card.text}
                              textAlign={card.textAlign}
                              content={card.content}
                              highlight={card.highlight}
                            />
                          )}
                        </Card>
                      </CardLink>
                    )}
                  </StyledCol>
                )
              })}
            </Row>
          </Col>
        </Row>
      </Grid>
    </CardSection>
  )
}

BlockCards.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  flat: PropTypes.boolean,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      ctaText: PropTypes.string,
      imageAlt: PropTypes.string,
      imageSrc: PropTypes.string,
      text: PropTypes.string.isRequired,
      textAlign: PropTypes.string,
      content: PropTypes.string,
      url: PropTypes.string,
      youtubeVideoId: PropTypes.string,
      linkComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      borderColor: PropTypes.string,
    })
  ),
  containerWidth: PropTypes.oneOf(['md', 'lg']),
  ctaAsLink: PropTypes.bool,
  cardsAsRows: PropTypes.bool,
}

BlockCards.defaultProps = {
  size: 'xl',
  containerWidth: 'lg',
  ctaAsLink: false,
  cardsAsRows: false,
}

export default BlockCards
